const trimTrailingSlash = (value) => value.replace(/\/$/, '');

const defaultApiBaseUrl = 'http://localhost:3007';
const defaultWsUrl = 'ws://localhost:3005';

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || defaultApiBaseUrl
);

export const WS_URL = process.env.REACT_APP_WS_URL || defaultWsUrl;

export const buildApiUrl = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
